import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from '../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { aftcabinImageOptions } from './views/aftcabin'

class X40AftCabin extends Component {
    constructor(props) {
        super(props);
        this.handleLayoutChange = this.handleLayoutChange.bind(this);
    }

    handleLayoutChange(newValue) {
        let configuration = this.props.configuration;
        configuration.AftCabinLayout = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = aftcabinImageOptions;

        let image = <ConfiguratorImage boat="X4_0" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Aft Cabins' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Standard of the X4<sup>0</sup> is a double berth in the aft cabin. Optional is a freeboard hung sea berth and upper shelves. The 2 cabin version is available from the Autumn of 2019.' /></p>
                    <p><Trans defaults='From Spring 2020, we can deliver the X4<sup>0</sup> in a 3 cabin version also.' /></p>

                    <RadioGroup options={this.props.aftCabinOptions} value={this.props.configuration.AftCabinLayout} onChange={this.handleLayoutChange} />
                    
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X40AftCabin);


// WEBPACK FOOTER //
// ./src/X40/X40AftCabin.js